// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (min-width: 1400px) and (max-width: 2400px) {
  div.container-body {
    height: 320px;
  }
}
@media (min-width: 1300px) and (max-width: 1400px) {
  div.container-body {
    height: 320px;
  }
}
@media (max-width: 1300px) and (min-width: 1000px) {
  div.container-body {
    height: 575px;
  }
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
